/** @param {string|null} id */
export function setAnalyticsUserId(id) {
    globalThis.window?.myFirebase?.setUserId?.(id);
}

export function getActivationSource() {
    return activationAttributionValue('utm_source');
}

export function getActivationCampaign() {
    return activationAttributionValue('utm_campaign');
}

export function getCustomerJourneyAttribution() {
    const query = new URLSearchParams(globalThis.window?.location?.search ?? '');
    const context = {};
    for (const [parameter, key] of [['utm_source', 'source'], ['utm_medium', 'medium'], ['utm_campaign', 'campaign']]) {
        const value = query.get(parameter)?.trim();
        if (value) context[key] = value.slice(0, key === 'campaign' ? 120 : 80);
    }
    const path = globalThis.window?.location?.pathname;
    if (path) context.landing_path = path.slice(0, 200);
    const referrer = globalThis.document?.referrer;
    if (referrer) {
        try {
            const url = new URL(referrer);
            if (url.protocol === 'https:' || url.protocol === 'http:') context.referrer_host = url.hostname.slice(0, 200);
        } catch { /* A malformed browser referrer carries no usable attribution. */ }
    }
    return JSON.stringify(context);
}

function activationAttributionValue(key) {
    const query = new URLSearchParams(globalThis.window?.location?.search ?? '');
    const value = query.get(key)?.trim();
    return value ? value.slice(0, key === 'utm_source' ? 80 : 120) : null;
}

/** @param {string|null} accountType */
export function setAnalyticsAccountType(accountType) {
    globalThis.window?.myFirebase?.setAccountType?.(accountType);
}

/** @param {string} releaseVersion */
export function setAnalyticsReleaseVersion(releaseVersion) {
    if (globalThis.window) {
        globalThis.window.myFirebaseReleaseVersion = releaseVersion;
        globalThis.window.myTrackingEnabled = !releaseVersion.endsWith("-DEV");
    }
}

export async function getAnalyticsMeasurementIdentity() {
    return await globalThis.window?.myFirebase?.getMeasurementIdentity?.() ?? null;
}

/**
 * @param {string} eventName
 * @param {string} method
 * @param {string} flow
 * @param {string} plan
 * @param {number} steps
 * @param {number} photoCount
 * @param {string} modelId
 * @param {number} quantity
 * @param {string} paywallTrigger
 * @param {string} provider
 * @param {string} itemId
 * @param {number} value
 * @param {string} currency
 * @param {string} paywallType
 * @param {string} targetTier
 * @param {string} selectedTier
 * @param {string} cadence
 * @param {string} packageId
 * @param {string} countryGroup
 * @param {string} paywallVariant
 * @param {string} selectionType
 * @param {string} failureStage
 * @param {string} failureCode
 * @param {string} conversionId
 * @param {string} clientPlatform
 * @param {string} releaseVersion
 * @param {string} configKey
 * @param {string} configValue
 * @param {number} configVersion
 * @param {string} configSource
 * @param {string} configDecision
 * @param {string} additionalParametersJson
 */
export function logFunnelEvent(
    eventName,
    method,
    flow,
    plan,
    steps,
    photoCount,
    modelId,
    quantity,
    paywallTrigger,
    provider,
    itemId,
    value,
    currency,
    paywallType,
    targetTier,
    selectedTier,
    cadence,
    packageId,
    countryGroup,
    paywallVariant,
    selectionType,
    failureStage,
    failureCode,
    conversionId,
    clientPlatform,
    releaseVersion,
    configKey,
    configValue,
    configVersion,
    configSource,
    configDecision,
    additionalParametersJson,
) {
    globalThis.window?.myFirebase?.logFunnelEvent?.(
        eventName,
        method,
        flow,
        plan,
        steps,
        photoCount,
        modelId,
        quantity,
        paywallTrigger,
        provider,
        itemId,
        value,
        currency,
        paywallType,
        targetTier,
        selectedTier,
        cadence,
        packageId,
        countryGroup,
        paywallVariant,
        selectionType,
        failureStage,
        failureCode,
        conversionId,
        clientPlatform,
        releaseVersion,
        configKey,
        configValue,
        configVersion,
        configSource,
        configDecision,
        additionalParametersJson,
    );
}

/**
 * @param {string} conversionId
 * @param {string} productId
 * @param {number} value
 * @param {string} currency
 * @param {string} releaseVersion
 */
export function logVerifiedPurchase(conversionId, productId, value, currency, releaseVersion) {
    globalThis.window?.myFirebase?.logEvent?.("purchase_verified", {
        conversion_id: conversionId,
        product_id: productId,
        currency,
        value,
        release_version: releaseVersion,
    });
}

/**
 * @param {string} eventName
 * @param {string} contentId
 * @param {number} value
 * @param {string} currency
 * @param {string} eventId
 */
export function logTikTokEvent(eventName, contentId, value, currency, eventId) {
    globalThis.window?.myTikTok?.logEvent?.(
        eventName,
        contentId,
        value,
        currency,
        eventId,
    );
}
